import { render, staticRenderFns } from "./HazardList.vue?vue&type=template&id=81e93fac"
import script from "./HazardList.vue?vue&type=script&lang=ts"
export * from "./HazardList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports